<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <h4 class="title" :style="{'font-size': '20px','font-weight':'600'}">
            {{$I18n("commission_02")}}
          </h4>
          <h4 :style="{'margin-top': '6px','margin-bottom': '12px','font-size':'44px','font-weight':'600'}">
            {{money == 0 ?"0" :`${money}` }}
          </h4>
        </md-card-header>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片头 -->
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>{{icon}}</md-icon>
          </div>
          <h4 class="title">{{title}}</h4>
        </md-card-header>
        <!-- 卡片主体(表单) -->
        <div class="md-layout card-form">
          <div class="md-layout md-layout-item" style="max-width: 260px;">
            <!-- 公司 -->
            <div class="md-layout-item md-size-100 left-layout-item">
              <md-field>
                <label>{{$I18n("company")}}</label>
                <md-select v-model="searchForm.comp_id">
                  <md-option 
                    v-for="item in companys" 
                    :value="item.comp_id" 
                    :key="item.comp_id">
                    {{item.comp_short_name ?item.comp_short_name : item.comp_name}}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-layout-item" style="max-width: 260px;">
            <!-- 创建时间 (date) -->
            <div class="md-layout-item md-size-100 left-layout-item">
              <md-field class="md-theme-default md-has-value">
                <!-- <label>{{$I18n("create_time")}}</label> -->
                <el-date-picker
                  class="md-date-form-item"
                  align="left"
                  v-model="searchForm.time"
                  type="daterange"
                  prefixIcon="no"
                  range-separator="~"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  :start-placeholder="$I18n('start')"
                  :end-placeholder="$I18n('end')">
                </el-date-picker>
              </md-field>
            </div>
          </div>
          <div class="md-layout-item">
            <md-button class= "left-icon md-info" @click="form_changeSearchData">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
          </div>
        </div>
        <!-- 卡片主体(表格) -->
        <md-card-content>
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('flow_id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('trading_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('source_type')">{{ item.source_type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('set_amount')">{{ item.money_type_name }}{{ item.order_price ?item.order_price :0 }}</md-table-cell>
              <md-table-cell :md-label="$I18n('order_cost')">{{ item.money_type_name }}{{ item.order_cost ?item.order_cost :0 }}</md-table-cell>
              <md-table-cell :md-label="$I18n('transaction_price')">{{ item.money_type_name }}{{ item.order_transaction_fee ?item.order_transaction_fee :0 }}</md-table-cell>
              <md-table-cell :md-label="$I18n('commission')">{{ item.money_type_name }}{{ item.money }}</md-table-cell>
              <md-table-cell :md-label="$I18n('commission_before')">{{ item.money_type_name }}{{ item.old_money ?item.old_money :0 }}</md-table-cell>
              <md-table-cell :md-label="$I18n('commission_after')">{{ item.money_type_name }}{{ item.new_money ?item.new_money :0 }}</md-table-cell>
              <md-table-cell :md-label="$I18n('order_details')">{{ item.order_name ?item.order_name :"" }}</md-table-cell>
              <md-table-cell :md-label="$I18n('pay_id')">{{ item.pay_order_id === "0" ?item.to_comp_name :item.pay_order_id}}</md-table-cell>
            </md-table-row>


            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <md-card-actions v-if="total > 0" md-alignment="space-between">
          <div class="">
            <p class="card-category">
              {{$I18n("total" )}} : {{total}}
            </p>
          </div>
          <pagination
            class="pagination-no-border"
            type= "info"
            v-model="currentPage"
            :per-page="pageSize"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import { Pagination } from "@/components";
// import { Modal } from '@/components';
import { timestampToString } from "@/common/tools.js";
export default {
  components: {
    Pagination,
    // Modal,
  },
  data() {
    return {
      money:0,
      currency_code:'',
      companys : [],

      title : this.$I18n("comm_rec"),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      searchForm : {
        type : 0,
        comp_id: this.UserInfo.comp_id,
        time:["",""],
      },
      searchData : {
        type : 0,
        comp_id: this.UserInfo.comp_id,
        comp_path: this.UserInfo.comp_path,
        time:["",""],
      },
      // 表格相关
      icon  : "payment",
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,

    };
  },
  mounted : function() {
    this.$api.getCompanyList({})
      .then(this.$Then(res => {
        this.companys = res.data;
        this.api_getPageData();
        this.api_getBalance();
      }))
      .catch(this.$Catch())
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          let type_name = "";
          switch(parseInt(item.type)){
            case 1: 
              type_name = this.$I18n("recharge");
              break;
            case 2: 
              type_name = this.$I18n("consume");
              break;
            case 3: 
              type_name = this.$I18n("trans_out");
              break;
            case 4: 
              type_name = this.$I18n("commission");
              break;
            case 5: 
              type_name = this.$I18n("tran_comm_bala");
              break;
            default : 
              type_name = this.$I18n("unknow");
              break;
          }
          let money_type_name = item.currency_code 
            ?this.$I18n("curr_" + item.currency_code)
            :this.$I18n('unknow');

          let source_type_name = "";
          switch(parseInt(item.source_type)){
            case 1: 
              source_type_name = this.$I18n("stand_user");
              break;
            case 2: 
              source_type_name = this.$I18n("sub_enter");
              break;
            default : 
              source_type_name = this.$I18n("unknow");
              break;
          }

          return {
            type_name,
            money_type_name,
            source_type_name,
            ... item,
            create_time : timestampToString(item.gmt_create * 1000),
          }
        })
      }
    },
  },
  methods: {
    // 
    api_getBalance(){
      this.$api.getBalance({})
        .then(this.$Then(res => {
          let str = "";
          str = ""
          const json = JSON.parse(res.data?.rebate_balance ?? '{}')
          for(var key in json){
            str = str + (str ?", " :"") + this.$I18n("curr_" + key) + ": " + json[key]
          }
          if(str === ""){
            str = "0"
          }
          this.money = str;
          // this.currency_code = res.data.currency_code
        }))
        .catch(this.$Catch())
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData(){
      const path = this.companys.filter(i => i.comp_id === this.searchData.comp_id)[0]?.path;
      this.searchData = {
        ...this.searchForm,
        comp_path: path ?path :"",
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getUserFlow({
          ...this.searchData,
          money_type: 2,
          page_size: this.pageSize,
          page_no: this.currentPage,
          gmt_start: this.searchData.time && this.searchData.time[0] ? new Date(this.searchData.time[0]).getTime()/1000 :"",
          gmt_end: this.searchData.time && this.searchData.time[1] ? new Date(this.searchData.time[1]).getTime()/1000 :"",
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.openModal = false;
      this.error.file = false;
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .modal-date.md-date-form-item{
    width: 0;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
    text-align: left;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
